import { ReactNode } from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { colors, mediumShadow, spacing } from 'ui/theme';

type Props = {
  children: ReactNode;
  zIndex?: number;
};

const StyledActionBarContainer = styled.div`
  align-items: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: flex-start;
  height: ${pxToRem(70)};
  padding: 0 ${spacing.threeQuarter} 0;
`;

const StyledActionBar = styled.menu`
  align-items: center;
  background-color: ${colors.white};
  border: solid ${spacing.single} ${colors.grey5};
  border-radius: ${spacing.quarter};
  display: flex;
  height: ${pxToRem(60)};
  justify-content: space-between;
  margin: 0;
  padding: 0 ${spacing.threeQuarter};
  ${mediumShadow};
`;

export const ACTION_BAR_TEST_ID = 'fullscreen-action-bar';

export const ActionBar = ({ children, ...props }: Props) => {
  return (
    <StyledActionBarContainer>
      <StyledActionBar data-test={ACTION_BAR_TEST_ID} {...props}>
        {children}
      </StyledActionBar>
    </StyledActionBarContainer>
  );
};
